import { Button } from "@mantine/core";
import { IconDeviceFloppy, IconHistory, IconPlus } from "@tabler/icons-react";
import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useIsOnline } from "src/hooks";
import { type ILink } from "src/interfaces";
import { ButtonsWrapper } from "src/styled";

interface Props {
  onAdd?: () => void;
  isSaving: boolean;
  canSave?: boolean;
  children?: ReactNode;
  section: string;
  customLinks?: ILink[] | ((links: ILink[]) => ILink[]);
}

const YachtSetupSectionHeader = ({
  onAdd,
  isSaving,
  canSave = true,
  children,
  section,
  customLinks,
}: Props) => {
  const isOnline = useIsOnline();
  const navigate = useNavigate();

  return (
    <Breadcrumbs customLinks={customLinks}>
      <ButtonsWrapper>
        {children}
        {onAdd && canSave && isOnline && (
          <Button
            onClick={onAdd}
            variant="outline"
            leftSection={<IconPlus size="1.4rem" />}>
            Add
          </Button>
        )}
        <Button
          onClick={() => navigate(`/settings/yacht/history/${section}`)}
          leftSection={<IconHistory size="1.4rem" />}
          variant="outline">
          History
        </Button>
        {canSave && isOnline && (
          <Button
            type="submit"
            leftSection={<IconDeviceFloppy size="1.4rem" />}
            variant="outline"
            loading={isSaving}>
            Save
          </Button>
        )}
      </ButtonsWrapper>
    </Breadcrumbs>
  );
};

export default YachtSetupSectionHeader;
